export const defaultTimer = 30000;